import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let SET_LOADING = 'SET_LOADING'

export default new Vuex.Store({
	state: {
		loading: false,
		$APP: 0 // 0不在APP内 1 在APP内
	},
	mutations: {
		[SET_LOADING](state, param) {
			state.loading = param;
		},
		setPayCommom(state, params) {
			state.payCommom = params
		},
		set_APP: (state, app) => {
			state.$APP = app;
		}
	},
	getters: {
		getPayCommom(state) {
			return state.payCommom
		},
		$APP(state) {
			return state.$APP;
		}
	},
	actions: {
		set_APP({
			commit
		}, data) {
			commit("set_APP", data);
		}
	}
})